export default "__VITE_ASSET__f8d64984__"